import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    // Log to console and GA if available
    console.error('React error boundary caught:', error, info)
    if (typeof window !== 'undefined' && window.gtag) {
      try {
        window.gtag('event', 'exception', {
          description: String(error && error.message ? error.message : error),
          fatal: true,
        })
      } catch {
        // Ignore gtag errors
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100svh' }} className="flex items-center justify-center px-4 py-10 text-white bg-black">
          <div className="max-w-prose text-center">
            <h1 className="text-2xl font-semibold mb-2">Something went wrong</h1>
            <p className="text-white/80 mb-4">Please refresh the page. If the issue persists, try an incognito window or another browser.</p>
            <div className="text-left bg-gray-900 p-4 rounded mb-4 overflow-auto max-h-96 text-red-400 font-mono text-sm">
              <p>{this.state.error && this.state.error.toString()}</p>
              <pre>{this.state.error && this.state.error.stack}</pre>
            </div>
            <button
              className="bg-ap-blurple hover:bg-ap-blurple/90 text-white rounded px-4 py-2"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
